import { combineReducers } from 'redux';

import assuntosProblemas from './assuntos/reducer';
import problemas from './problemas/reducer';

export default combineReducers({
	assuntosProblemas,
	problemas,
});
